"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProductionEnvironment = void 0;
var isProductionEnvironment = function () {
    return process.env.NODE_ENV === 'production';
};
exports.isProductionEnvironment = isProductionEnvironment;
//# sourceMappingURL=checkEnvironment.js.map